import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices/DomainServicesContext";

import { getQueryKey } from "./useCollection";
import { getAccessQueryKey } from "./useCollectionAccess";

interface DeleteCollectionVariables {
  collectionId: string;
  resourceOwnerId: string;
}

export function useDeleteCollection() {
  const { collections } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<void, Error, DeleteCollectionVariables>({
    mutationFn: ({ collectionId, resourceOwnerId }) =>
      collections.deleteCollection(collectionId, { resourceOwnerId }),
    onSuccess: (_, { collectionId }) => {
      queryClient.removeQueries({ queryKey: getQueryKey(collectionId) });
      queryClient.removeQueries({ queryKey: getAccessQueryKey(collectionId) });
    },
  });
}
